import React from "react";
import { InboxIcon } from "@heroicons/react/24/outline";

export default function EmptyState({ showAll, onRefresh, onShowAll }) {
  return (
    <div className="px-6 py-16 text-center">
      <InboxIcon className="mx-auto mb-4 h-12 w-12 text-text-muted" />
      <h3 className="mb-1 text-lg font-semibold text-text-primary">
        {showAll ? "Объявлений не найдено" : "Очередь пуста"}
      </h3>
      <p className="mb-6 text-sm text-text-secondary">
        {showAll ? "Попробуйте изменить фильтры." : "Все объявления проверены. Новые появятся здесь."}
      </p>
      <div className="flex justify-center gap-3">
        <button
          type="button"
          onClick={onRefresh}
          className="rounded-lg bg-accent-grad px-4 py-2 text-sm font-semibold text-white hover:opacity-90"
        >
          Обновить
        </button>
        {!showAll && (
          <button
            type="button"
            onClick={onShowAll}
            className="rounded-lg border border-border-primary px-4 py-2 text-sm font-medium text-text-secondary hover:bg-bg-tertiary"
          >
            Показать все объявления
          </button>
        )}
      </div>
    </div>
  );
}
